export default __webpack_public_path__ + "static/media/istock-1140524580_3.03f0a28f.jpg";